// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"d1201c2f","192":"3b3cd6d2","336":"b918f176","453":"20359781","459":"a7a44036"}[chunkId] + ".chunk.js";
};